// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getFirestore} from "@firebase/firestore"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD_3XOCdKKMRqsVbgcyZMSvRPx1eJ49Ado",
  authDomain: "shayfabriziodotcom.firebaseapp.com",
  projectId: "shayfabriziodotcom",
  storageBucket: "shayfabriziodotcom.appspot.com",
  messagingSenderId: "1009004008059",
  appId: "1:1009004008059:web:a439c0d6cfb6af486f48de",
  measurementId: "G-C1DE5E4T7Y"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export default getFirestore();


